var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "-0.45 -0.45 38 37",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.074 19.901l-4.197 6.923c-.665 1.096-1.885 1.77-3.204 1.77H4.496c-1.074 0-1.742-1.12-1.202-2.012l4.197-6.923c.665-1.096 1.885-1.77 3.204-1.77h23.178c1.073 0 1.742 1.12 1.2 2.012zm-24.38-3.796h19.008v-2.677c0-1.478-1.245-2.676-2.781-2.676h-9.272L13.94 7.183H4.668c-1.536 0-2.781 1.199-2.781 2.677v15.503L5.89 18.76c.993-1.638 2.834-2.655 4.805-2.655z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.0c9a8baad5c8ff009573e288c09c33b3.svg";
export { ForwardRef as ReactComponent };